import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';

import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import {ForgetPasswordPageComponent} from "./studentportal/components/forget-password/forget-password-page.component";
import {RegistrationformComponent} from "./studentportal/components/Registration/registrationform.component";

import { ChecklistRegistrationInfoComponent } from './studentportal/components/Registration/checklist-registration-info.component';
import{RegistrationwelcomeformComponent} from './studentportal/components/Registration/registrationwelcomeform.component';
import { ChecklistRegistrationwithprnInfoComponent } from './studentportal/components/Registration/checklist-registrationwithprn-info.component';
import { StudentverifywithprnComponent } from './studentportal/components/Registration/studentverifywithprn.component';
import { MeritlinkComponent } from './studentportal/components/Registration/meritlink.component';


const routes: Routes = [
    {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [ AuthGuardService]
  },
  {
    path: 'forgetPassword',
    component:ForgetPasswordPageComponent,
    data: {
      breadcrumb: "Forgot Password",
      headerLabel: "Forgot Password"
    }
    // canActivate: [ AuthGuardService ]
  },
  {
    path: 'registrationForm',
    component: RegistrationformComponent,
    data: {
      breadcrumb: "Registration",
      headerLabel: "Registration"
    }
  },
  {
    path: 'studentverifywithprn',
    component: StudentverifywithprnComponent,
    data: {
      breadcrumb: "a",
      headerLabel: "a"
    }
  },
  
  {
    path: 'checklist-registration-info',
    component: ChecklistRegistrationInfoComponent,
    data: {
      breadcrumb: "Information",
      headerLabel: "Information"
    }
  },
  {
    path: 'checklist-registrationwithprn-info',
    component: ChecklistRegistrationwithprnInfoComponent,
    data: {
      breadcrumb: "Information",
      headerLabel: "Information"
    }
  },
  {
    path: 'meritlink',
    component: MeritlinkComponent,
    data: {
      breadcrumb: "Merit Link",
      headerLabel: "Merit Link",
    }
  },
  /* {
    path: 'registrationwelcomeform',
    component: RegistrationwelcomeformComponent,
    data: {
      breadcrumb: "Welcome",
      headerLabel: "Welcome"
    }
  }, */

  
  {
    path: 'studentportal',
    canActivate: [AuthGuardService],
    loadChildren: './studentportal/studentportal.module#StudentportalModule',
    data: {
      breadcrumb: "Dashboard",
      headerLabel: "Dashboard"
    }

  },

 /*  {
    path: 'universityportal',
    canActivate: [AuthGuardService],
    loadChildren: './universityportal/universityportal.module#UniversityportalModule',
    data: {
      breadcrumb: "University Department",
      headerLabel: "University Department"
    }

  }, */
  {
    path: 'changerequest',
    canActivate: [AuthGuardService],
    loadChildren: './changerequest/changerequest.module#ChangerequestModule',
    data: {
      breadcrumb: "Request",
      headerLabel: "Request"
    }

  },  
  {
    path: 'certificates',
    canActivate: [AuthGuardService],
    loadChildren: './certificates/certificates.module#CertificatesModule',
    data: {
      breadcrumb: "Certificate",
      headerLabel: "Certificate"
    }

  },  
  {
    path: 'revaluation',
    canActivate: [AuthGuardService],
    loadChildren: './revaluation/revaluation.module#RevaluationModule',
    data: {
      breadcrumb: "Result Query",
      headerLabel: "Result Query"
    }

  },  
  {
    path: 'convocation',
    canActivate: [AuthGuardService],
    loadChildren: './convocation/convocation.module#ConvocationModule',
    data: {
      breadcrumb: "Convocation",
      headerLabel: "Convocation"
    }
  },  
  {
    path: 'hostel',
    canActivate: [AuthGuardService],
    loadChildren: './hostel/hostel.module#HostelModule',
    data: {
      breadcrumb: "Hostel",
      headerLabel: "Hostel"
    }
  },  
  {
    path: 'placement',
    canActivate: [AuthGuardService],
    loadChildren: './placement/placement.module#PlacementModule',
    data: {
      breadcrumb: "Placement",
      headerLabel: "Placement"
    }
  },
  {
    path: 'scholarship',
    canActivate: [AuthGuardService],
    loadChildren: './scholarship/scholarship.module#ScholarshipModule',
    data: {
      breadcrumb: "Scholarship",
      headerLabel: "Scholarship"
    }
  },  
  {
    path: 'feedback',
    canActivate: [AuthGuardService],
    loadChildren: './feedback/feedback.module#FeedbackModule',
    data: {
      breadcrumb: "Feedback",
      headerLabel: "Feedback"
    }
  },  
  {
    path: '**',
    redirectTo: 'studentportal/dashboard',
    canActivate: [ AuthGuardService ],
    data: {
      breadcrumb: "Dashboard",
      headerLabel: "Dashboard"
    }
  }



];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true }), DxDataGridModule, DxFormModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
